import { CommonModule } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-share-redirect',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './share-redirect.component.html',
  styleUrls: ['./share-redirect.component.scss'],
})
export class ShareRedirectComponent implements OnDestroy {
  subscription: Subscription = new Subscription();
  constructor(private activatedRoute: ActivatedRoute, private router: Router) {
    this.subscription.add(
      this.activatedRoute.params.subscribe((params) => {
        const { id } = params;
        if (id) {
          this.router.navigateByUrl(`/baglanti-paylasimi/${id}`);
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
